class BESSAppNewProjectEditorManager extends BESSAppProjectEditorManagerBase {

    constructor(editor) {
        super(editor);
        this.saveFn = BESSAppProjectEditorAPIService.instance().apiNewProject.bind(BESSAppProjectEditorAPIService.instance());

        $('#app-editor-modal .app-editor-item-std').addClass('app-project-details-modal-item');
        this.createProjectFeedback = $('.app-create-project-feedback');
        this.createProjectFeedback.text('').removeClass('invalid');

        this.forEach(editor.node.find('.app-editor-field-label-only'), function (td) {
            let tr = $(td).parent();
            tr.addClass('app-project-details-intro-section');
        });

        editor.projectInputs = editor.items[0].inputs;
        this.introSection1 = this.editor.projectInputs.allInputs[0];
        this.bessEngineInput = this.editor.projectInputs.bessEngine;
        if (this.bessEngineInput !== undefined) {
            this.bessEngineInput.addChangeRule(this.updateState.bind(this))
        }

        this.lookupAddress = this.editor.projectInputs.lookupAddress;
        this.location = this.editor.projectInputs.map;

        this.gpsLatInput = this.editor.projectInputs.gpsLatitude;
        this.gpsLngInput = this.editor.projectInputs.gpsLongitude;

        this.locationManager = new BESSAppNewProjectEditorLocationManager(this);
        $('#app-editor-modal .app-action-save span').text('Create project');
        $('#app-editor-modal .app-action-close span').text('Cancel');

        this.updateState();
    }

    isValid() {
        let isValid = this.editor.isValid() && this.editor.projectInputs.projectName.hasValue();
        this.createProjectFeedback.addClassIf('invalid', !isValid);
        return isValid;
    }

    saved(result) {
        let projectId = result.project_id;
        window.location.href = '/app/project/' + projectId;
        return false;
    }

    updateState() {
        this.errorMsg = null;

        this.#updateForLatLng();
        this.#updateForSiteTypeAndArea();

        if (this.errorMsg != null) {
            this.createProjectFeedback.text(this.errorMsg)
        } else {
            this.createProjectFeedback.text('')
        }
    }

    #updateForLatLng() {
        let lng = this.gpsLngInput.getValue();
        let lat = this.gpsLatInput.getValue();
        let hasCoord = lng && lat;
        if (!hasCoord) {
            this.errorMsg = 'Please select a street address to get started.'
        } else {
            this.errorMsg = null;
        }
        this.forEach(this.editor.inputs, function (field) {
            if (field !== this.gpsLngInput && field !== this.gpsLatInput && field !== this.introSection1 && field !== this.lookupAddress) {
                field.node.addClassIf('invisible', !hasCoord);
            }
        });
    }

    #updateForSiteTypeAndArea() {
        if (this.errorMsg != null) return;
        if (this.editor.projectInputs.projectName.getValue() === null) {
            this.errorMsg = 'Please enter the name of the project.';
        }
        else if (this.editor.projectInputs.siteType.getValue() === null) {
            this.errorMsg = 'Please select your project site type';
        } else {
            if (!this.isValid()) {
                this.errorMsg = 'Please complete all required fields marked \'*\'';
            }
        }
    }

}